/**
 * Unified Chart Theme — Steel & Ember
 * -------------------------------------------------
 * Every Recharts component in the product consumes tokens
 * from this file. Orange is reserved for variance/alert only.
 */

export const chartColors = {
  // Multi-series sequence (priority order)
  sequence: [
    '#1E4E8C', // Steel Blue 500
    '#5790C9', // Steel Blue 300
    '#3A3F4A', // Graphite
    '#0E7C6B', // Verdigris
    '#143A6B', // Steel Blue 700
    '#9AA2B1', // Slate 400
    '#2E70AD', // Steel Blue 400
  ],
  // Reserved semantic
  alert:    '#F26B1F', // Ember — variance / critical only
  success:  '#0E7C6B',
  warning:  '#92580A',
  error:    '#7A1F1F',
};

export const chartAxis = {
  tick: {
    fontFamily: "'JetBrains Mono', monospace",
    fontSize: 11,
    fill: 'var(--nexus-text-tertiary)',
    fontFeatureSettings: "'tnum' 1",
  },
  line: { stroke: 'transparent' },
};

export const chartGrid = {
  stroke: 'var(--hairline)',
  strokeDasharray: '3 4',
  vertical: false,
};

export const chartTooltip = {
  contentStyle: {
    background: 'var(--layer-3)',
    border: '1px solid rgba(30, 78, 140, 0.4)',
    borderRadius: 10,
    boxShadow: 'var(--tinted-shadow-steel)',
    padding: '10px 12px',
  },
  labelStyle: {
    color: 'var(--nexus-text-primary)',
    fontFamily: "'JetBrains Mono', monospace",
    fontSize: 11,
    fontWeight: 500,
    marginBottom: 4,
    textTransform: 'uppercase',
    letterSpacing: '0.08em',
  },
  itemStyle: {
    color: 'var(--nexus-text-secondary)',
    fontFamily: "'JetBrains Mono', monospace",
    fontSize: 12,
    padding: '2px 0',
  },
  cursor: { stroke: 'rgba(30, 78, 140, 0.4)', strokeWidth: 1, strokeDasharray: '4 3' },
};

export const chartAnimation = {
  // Default entrance — line draw L→R, 1.2s easeOutQuart
  line: {
    isAnimationActive: true,
    animationBegin: 0,
    animationDuration: 1200,
    animationEasing: 'ease-out',
  },
  bar: {
    isAnimationActive: true,
    animationBegin: 0,
    animationDuration: 800,
    animationEasing: 'ease-out',
  },
  pie: {
    isAnimationActive: true,
    animationBegin: 0,
    animationDuration: 800,
    animationEasing: 'ease-out',
  },
};

/** Get a color by index, wrapping the sequence. */
export const colorFor = (index = 0) =>
  chartColors.sequence[index % chartColors.sequence.length];

export default { chartColors, chartAxis, chartGrid, chartTooltip, chartAnimation, colorFor };
